// extracted by mini-css-extract-plugin
module.exports =  {"links":"styles-module_links__Npfal2W_zbJpSQYtBpCH","video":"styles-module_video__ZfcGaYgRaRNlJ29u10LG"};